import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { show, hide } from 'store/reducers/modals' // eslint-disable-line no-unused-vars

import CutoffModal from './Cutoff'
import FeedbackModal from './Feedback'
import PackItemModal from './PackItem'
import PasswordlessModal from './Passwordless'
import PrintModal from './Print'
import classes from './Modals.scss'

class ModalsContainer extends React.Component {
  static propTypes = {
    modals: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  static defaultProps = {
    modals: {}
  }

  components = {
    cutoff: CutoffModal,
    feedback: FeedbackModal,
    packItem: PackItemModal,
    passwordless: PasswordlessModal,
    print: PrintModal
  }

  render () {
    if (!Object.keys(this.props.modals).length) return null

    return <div className={classes.container}>
      {Object.keys(this.props.modals)
        .map(modalId => {
          const modal = this.props.modals[modalId]
          const ModalComponent = this.components[modalId]

          if (!ModalComponent) {
            console.error(`Unable to render the modal ${modalId}.`)
            return null
          }

          let props = {
            isOpen: modal.open,
            closeAction: () => this.props.dispatch(hide(modalId)),
            successCallback: modal.successCallback,
            errorCallback: modal.errorCallback,
            key: `modal-${modalId}`
          }

          if (modal.props && modal.props.constructor === Object) props = Object.assign(props, modal.props)

          return <ModalComponent {...props} />
        })
      }
    </div>
  }
}

const mapStateToProps = (state, ownProps) => ({
  modals: state.modals
})
const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(ModalsContainer)



// WEBPACK FOOTER //
// ./src/containers/Modals/ModalsContainer.js